import * as petRuleset from './pet.ruleset';

export * as getters from './pet.getters';
export * as modifiers from './pet.modifiers';

export const ruleset = petRuleset;

export type Evolution = {
  species: petRuleset.PetSpeciesID;
  stage: petRuleset.PetEvolutionStage;
  timestamp: number;
};

export type {
  PetAttribute,
  PetStatusEffect,
  PetState,
  PetEvolutionStage,
  PetEvolution,
  PetSpeciesID,
} from './pet.ruleset';
